import axios from "axios";
import { Agency } from "../models/Agency";

function find(id: string): Promise<Agency> {
  return new Promise((resolve, reject) => {
    axios.get(`${process.env.REACT_APP_API_URL}agencies/${id}`)
        .then((response) => {
          resolve(new Agency(response.data))
        })
        .catch((error) => {
          switch (error.response.status) {
            case 404:
              reject({status: error.response.status, message: "Agence inconnue"});
              break;
            default:
              reject({status: error.response.status, message: "Erreur inconnue"});
          }
        })
  })
}

export default {
  find,
};
